import { render, staticRenderFns } from "./profileView.vue?vue&type=template&id=40f111fc&scoped=true&"
import script from "./profileview.js?vue&type=script&lang=js&"
export * from "./profileview.js?vue&type=script&lang=js&"
import style0 from "./profileview.scss?vue&type=style&index=0&id=40f111fc&prod&lang=scss&scoped=true&"
import style1 from "./profileView.vue?vue&type=style&index=1&id=40f111fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f111fc",
  null
  
)

export default component.exports